import { SpecialProductDimensionService } from './../../services/special-product-dimension-service';
import { DialogService } from 'aurelia-dialog';
import { EventAggregator } from 'aurelia-event-aggregator';
import { bindable } from 'aurelia-framework';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Prompt } from 'elements/prompt';
import { Models } from 'models/core';
import * as moment from 'moment';
import { DisinfectionTypeService } from 'services/disinfection-type-service';
import { ErrorService } from 'services/error-service';
import { NetDimensionService } from 'services/net-dimension-service';
import { NetService } from 'services/net-service';
import { ServiceService } from 'services/service-service';
import { ToastService } from 'services/toast-service';
import { Utility } from '../../utility';
import { IndustryService } from 'services/industry-service';
import { DetergentTypeService } from 'services/detergent-type-service';
import { InvoiceBadge } from 'components/badge/invoice-badge';
import { I18N } from 'aurelia-i18n';
import { ServiceConsumptionWashingService } from 'services/service-consumption-washing-service';
import { ServiceConsumptionWashingModel } from 'features/service-washing-consumption-create-edit';
import { ServiceInvoiceStatus } from 'models/ServiceInvoiceStatus';
import { ServiceProductService } from 'services/service-product-service';
import { ForeignObjectTypeServiceService } from 'services/foreign-object-type-service-service';
import { ForeignObjectService } from 'services/foreign-object-service';
import { ValidationController } from 'aurelia-validation';
import { StandardValidationBuilder } from 'lib/validation';
import { ConfirmDialog } from 'components/dialogs/confirm/confirm-dialog';
import { AsyncErrorHandler } from 'lib/ui';
import { ForeignObjectModel } from 'features/foreign-object-create-edit';
import { ServiceConsumptionMaterialWashingService } from 'services/service-consumption-material-washing-service';
import { CustomerService } from 'services/customer-service';
import { InvoiceWasteBy } from 'models/InvoiceWasteBy';

@autoinject
export class ServiceDetailWash {
  private net: Models.Net;
  private service: Models.Service;
  private nextTabIndex: number = null;

  private serviceConsumptionWashing: Models.ServiceConsumptionWashing[];

  protected headersConsumptionMaterialWashing = [];
  private serviceConsumptionMaterialWashings: Models.ServiceConsumptionMaterialWashing[];
  private invoiceServiceConsumptionWashingStatus: string;

  private foreignObjectTypesService: Models.ForeignObjectTypeService[];
  private unusedForeignObjectTypesService: Models.ForeignObjectTypeService[];

  private foreignObjects: Models.ForeignObject[];
  private foreignObjectHeaders = [];
  private invoiceForeignObjectsStatus: string;

  protected headers = [];
  protected serviceInvoiceStatus: ServiceInvoiceStatus;

  private weightNewNetString = '';

  private customer: Models.Customer;
  private amountWasteText: string;
  private unitWasteText: string;

  private invoiceConsumptionWashingStatus: string;
  private noConsumptionWashingRegistered: boolean;

  @bindable private serviceId: number;
  @bindable private netId: number;

  specialProductDimension: Models.SpecialProductDimension;
  netdimension: Models.NetDimension;
  originalObject: Models.Service;
  locked = false;
  isSpecialProduct: boolean | undefined;
  isFisheryServiceStation: boolean | undefined;
  @bindable isDialog = false;

  constructor(
    private t: I18N,
    private dialogService: DialogService,
    private errorService: ErrorService,
    private eventAggregator: EventAggregator,
    private netService: NetService,
    private router: Router,
    private toastService: ToastService,
    private utility: Utility,
    private confirmation: ConfirmDialog,
    private serviceService: ServiceService,
    private netDimensionService: NetDimensionService,
    private specialProductDimensionService: SpecialProductDimensionService,
    private disinfectionTypeService: DisinfectionTypeService,
    private detergentTypeService: DetergentTypeService,
    private serviceConsumptionWashingService: ServiceConsumptionWashingService,
    private serviceProductservice: ServiceProductService,
    private industryService: IndustryService,
    private foreignObjectTypeServiceService: ForeignObjectTypeServiceService,
    private foreignObjectService: ForeignObjectService,
    private serviceConsumptionMaterialWashingService: ServiceConsumptionMaterialWashingService,
    private ruleBuilder: StandardValidationBuilder,
    protected validationController: ValidationController,
    private customerService: CustomerService
  ) {
    this.createHeaders();
    this.createHeadersConsumptionMaterialWashing();
  }

  protected async attached() {
    if (this.serviceId && this.netId) {
      await this.activate({ Id: this.serviceId, NetId: this.netId });
      this.createValidationRules();
      this.createHeadersForeignObject();
    }
  }

  protected invoiceStatusMaterialUse = undefined;

  private async activate(params: { Id: number; NetId: number }) {
    this.serviceId = params.Id;
    this.netId = params.NetId;

    await this.getService(params.Id);
    this.getNet(params.NetId);
    await this.getSericeWashing(this.serviceId || params.Id);
    await this.getServiceConsumptionMaterialWashing(this.serviceId);
    void this.getServiceInvoiceStatus(params.Id);
    await this.getForeignObjects(this.serviceId);

    // Get new tabIndex for tabs component via EA, store value so we can publish this if canDeactivate returns true
    this.eventAggregator.subscribe('changeTab', (tabIndex: number) => {
      this.nextTabIndex = tabIndex;
    });
  }

  private async getServiceInvoiceStatus(serviceId: number) {
    try {
      this.serviceInvoiceStatus = await this.serviceService.getServiceInvoiceStaatus(serviceId);
    } catch (error) {
      //
    }
  }

  private async addForeignObject(foreignObjectTypeService: Models.ForeignObjectTypeService) {
    const newForeignObject: Models.ForeignObject = {
      ForeignObjectTypeServiceId: foreignObjectTypeService.Id,
      ServiceId: this.serviceId,
    };

    this.eventAggregator.publish('dropdownClose', 1);
    await this.foreignObjectService.post(newForeignObject);
    this.foreignObjects = await this.foreignObjectService.getAll('?$expand=ForeignObjectTypeService&$filter=ServiceId eq ' + this.serviceId);
    if (this.service.IsInvoicingCompatible) {
      const invoiceForeignObjectsStatusList = this.foreignObjects
        .filter((x) => x.ForeignObjectTypeService.ProductId)
        .map((x) => (x.ServiceInvoiceId ? true : false));
      this.invoiceForeignObjectsStatus = InvoiceBadge.GetInvoiceType(invoiceForeignObjectsStatusList);
    }
  }

  private async deleteForeignObject(foreignObjectId: number) {
    await this.foreignObjectService.delete(foreignObjectId);
    this.foreignObjects = await this.foreignObjectService.getAll('?$expand=ForeignObjectTypeService&$filter=ServiceId eq ' + this.serviceId);
    if (this.service.IsInvoicingCompatible) {
      const invoiceForeignObjectsStatusList = this.foreignObjects
        .filter((x) => x.ForeignObjectTypeService.ProductId)
        .map((x) => (x.ServiceInvoiceId ? true : false));
      this.invoiceForeignObjectsStatus = InvoiceBadge.GetInvoiceType(invoiceForeignObjectsStatusList);
    }
  }

  protected isCreating = false;
  setIsCreating(isCreating: boolean) {
    this.editingConsumptionWashing = undefined;
    this.isCreating = isCreating;
  }

  editingConsumptionWashing: number | undefined = undefined;
  setEditingConsumptionWashing(consumptionWashingId: number) {
    this.isCreating = false;
    this.editingConsumptionWashing = consumptionWashingId;
  }

  protected isCreatingServiceConsumptionMaterialWashing = false;
  setIsCreatingServiceConsumptionMaterialWashing(isCreatingServiceConsumptionMaterialWashing: boolean) {
    this.editingServiceConsumptionMaterialWashing = undefined;
    this.isCreatingServiceConsumptionMaterialWashing = isCreatingServiceConsumptionMaterialWashing;
  }

  editingServiceConsumptionMaterialWashing: number | undefined = undefined;
  setEditingServiceConsumptionMaterialWashing(serviceConsumptionMaterialWashingId: number) {
    this.isCreatingServiceConsumptionMaterialWashing = false;
    this.editingServiceConsumptionMaterialWashing = serviceConsumptionMaterialWashingId;
  }

  protected isCreatingForeignObject = false;
  setIsCreatingForeignObject(isCreatingForeignObject: boolean) {
    this.editForeignObject = undefined;
    this.isCreatingForeignObject = isCreatingForeignObject;
  }

  editForeignObject: number | undefined = undefined;
  setEditForeignObject(foreignObjectId: number) {
    this.isCreatingForeignObject = false;
    this.editForeignObject = foreignObjectId;
  }

  private async saveService() {
    try {
      this.service.DetergentType = null;
      await this.serviceService.put(this.service, this.service.Id);
      this.toastService.showSuccess('service.washSaved');
      this.eventAggregator.publish('serviceUpdated');
      this.updateOriginalObject();
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  private async saveServiceAndUpdateStatus(status: number, statusType: 'washing' | 'measuring') {

    if (statusType === 'washing') {
      if (this.serviceConsumptionWashing.length < 1) {
        this.noConsumptionWashingRegistered = true;
        return;
      } else {
        this.noConsumptionWashingRegistered = false;
        this.validationController.reset();
      }
    }

    if (statusType === 'measuring') {
      const { valid } = await this.validationController.validate();
      if (!valid) return;
    }

    this.serviceService
      .updateServiceStatus(status, this.service.Id)
      .then((res) => {
        if (!this.service.WashedDate) {
          this.service.WashedDate = res.WashedDate;
        }
        if (!this.service.MeasuredDate) {
          this.service.MeasuredDate = res.MeasuredDate;
        }
        this.toastService.showSuccess('service.serviceStatusChanged');
        this.saveService();
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private updateCircumference() {
    this.service.CircumferenceMeasured =
      (Number.parseFloat(`${this.service?.LengthMeasured}`) || 0) +
      (Number.parseFloat(`${this.service?.LengthMeasured2}`) || 0) +
      (Number.parseFloat(`${this.service?.WidthMeasured}`) || 0) +
      (Number.parseFloat(`${this.service?.WidthMeasured2}`) || 0);
  }

  private async getIndutry(id: number) {
    try {
      const industry = await this.industryService.get(id);
      this.isFisheryServiceStation = industry.Name == 'Fishery';
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  @AsyncErrorHandler
  async getService(id: number) {
    const res = await this.serviceService.get(id + '?$expand=ServiceStation');
    this.service = res;
    this.locked = res.Locked ? res.Locked : false;
    this.updateOriginalObject();
  }

  private getNet(id: number) {
    this.netService
      .getNetInfo(id)
      .then((res) => {
        this.net = res;
        this.getDimensions(res);
        this.isSpecialProduct = this.net.IsSpecialProduct;
        this.getCustomer(this.net.CustomerId);
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private getCustomer(id: number) {
    this.customerService
      .get(id)
      .then((customer) => {
        this.customer = customer;
        this.getAmountWasteText(customer.InvoiceWasteBy);
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private async getSericeWashing(serviceId: number) {
    const result = await this.serviceConsumptionWashingService.getAll(
      '?$expand=DisinfectionType($expand=Product),DetergentType($expand=Product)&$filter=ServiceId eq ' + serviceId
    );
    this.serviceConsumptionWashing = result;
    const invoiceConsumptionWashingStatusList = this.serviceConsumptionWashing.map((x) => (x.ServiceInvoiceId ? true : false));
    this.invoiceConsumptionWashingStatus = InvoiceBadge.GetInvoiceType(invoiceConsumptionWashingStatusList);
  }

  protected async onSave(data: ServiceConsumptionWashingModel) {
    if (data.Id) {
      await this.doUpdateWashingConsumption(data);
    } else {
      await this.doCreateWashingConsumption(data);
    }
  }

  protected async doCreateWashingConsumption(data: ServiceConsumptionWashingModel) {
    await this.serviceConsumptionWashingService.post(data as Models.ServiceConsumptionWashing);
    await this.onSaved('create');
  }

  protected async doUpdateWashingConsumption(data: ServiceConsumptionWashingModel) {
    await this.serviceConsumptionWashingService.put(data as Models.ServiceConsumptionWashing, data.Id);
    await this.onSaved('update');
  }

  protected async onSaved(type: 'create' | 'update') {
    if (type === 'create') {
      this.setIsCreating(false);
      this.toastService.showSuccess(this.t.tr('general.created'));
      await this.getSericeWashing(this.serviceId);
    } else {
      this.setEditingConsumptionWashing(undefined);
      this.toastService.showSuccess(this.t.tr('general.updated'));
      await this.getSericeWashing(this.serviceId);
    }
  }

  async onDelte(id: number) {
    try {
      await this.serviceConsumptionWashingService.delete(id);
      this.toastService.showSuccess(this.t.tr('general.entryDeleted'));
      await this.getSericeWashing(this.serviceId);
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  private async getServiceConsumptionMaterialWashing(serviceId: number) {
    const response = await this.serviceConsumptionMaterialWashingService.getAll(
      '?$expand=ConsumptionMaterialWashing($expand=Product),LocationCode&$filter=ServiceId eq ' + serviceId
    );
    this.serviceConsumptionMaterialWashings = response;
    const invoiceServiceConsumptionWashingStatusList = this.serviceConsumptionMaterialWashings.map((x) => (x.ServiceInvoiceId ? true : false));
    this.invoiceServiceConsumptionWashingStatus = InvoiceBadge.GetInvoiceType(invoiceServiceConsumptionWashingStatusList);
  }

  protected async onSaveServiceConsumptionMaterialWashing(data: Models.ServiceConsumptionMaterialWashing) {
    if (data.Id) {
      await this.doUpdateServiceConsumptionMaterialWashing(data);
    } else {
      await this.doCreateServiceConsumptionMaterialWashing(data);
    }
  }

  protected async doCreateServiceConsumptionMaterialWashing(data: Models.ServiceConsumptionMaterialWashing) {
    await this.serviceConsumptionMaterialWashingService.post(data as Models.ServiceConsumptionMaterialWashing);
    await this.onSavedServiceConsumptionMaterialWashing('create');
  }

  protected async doUpdateServiceConsumptionMaterialWashing(data: Models.ServiceConsumptionMaterialWashing) {
    await this.serviceConsumptionMaterialWashingService.put(data as Models.ServiceConsumptionMaterialWashing, data.Id);
    await this.onSavedServiceConsumptionMaterialWashing('update');
  }

  protected async onSavedServiceConsumptionMaterialWashing(type: 'create' | 'update') {
    if (type === 'create') {
      this.setIsCreatingServiceConsumptionMaterialWashing(false);
      this.toastService.showSuccess(this.t.tr('general.created'));
      await this.getServiceConsumptionMaterialWashing(this.serviceId);
    } else {
      this.setEditingServiceConsumptionMaterialWashing(undefined);
      this.toastService.showSuccess(this.t.tr('general.updated'));
      await this.getServiceConsumptionMaterialWashing(this.serviceId);
    }
  }

  protected async onDeleteServiceConsumptionMaterialWashing(id: number) {
    try {
      await this.serviceConsumptionMaterialWashingService.delete(id);
      this.toastService.showSuccess(this.t.tr('general.entryDeleted'));
      await this.getServiceConsumptionMaterialWashing(this.serviceId);
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  private async getForeignObjects(serviceId: number) {
    if (this.service.IsInvoicingCompatible) {
      this.foreignObjects = await this.foreignObjectService.getAll(
        '?$expand=ForeignObjectTypeService($expand=Product)&$filter=ServiceId eq ' + serviceId
      );
      const invoiceForeignObjectsStatusList = this.foreignObjects
        .filter((x) => x.ForeignObjectTypeService.ProductId)
        .map((x) => (x.ServiceInvoiceId ? true : false));
      this.invoiceForeignObjectsStatus = InvoiceBadge.GetInvoiceType(invoiceForeignObjectsStatusList);
    } else {
      const response = await this.foreignObjectTypeServiceService.getStandardForeignObjectTypeServices();
      this.foreignObjectTypesService = response.data;
      this.foreignObjects = await this.foreignObjectService.getAll('?$expand=ForeignObjectTypeService&$filter=ServiceId eq ' + this.serviceId);
    }
  }

  protected async onSaveForeignObject(data: ForeignObjectModel) {
    if (data.Id) {
      await this.doUpdateForeignObject(data);
    } else {
      await this.doCreateForeignObject(data);
    }
  }

  protected async doCreateForeignObject(data: ForeignObjectModel) {
    await this.foreignObjectService.post(data as Models.ForeignObject);
    await this.onSavedForeignObject('create');
  }

  protected async doUpdateForeignObject(data: ForeignObjectModel) {
    await this.foreignObjectService.put(data as Models.ForeignObject, data.Id);
    await this.onSavedForeignObject('update');
  }

  protected async onSavedForeignObject(type: 'create' | 'update') {
    if (type === 'create') {
      this.setIsCreatingForeignObject(false);
      this.toastService.showSuccess(this.t.tr('general.created'));
      await this.getForeignObjects(this.serviceId);
    } else {
      this.setEditForeignObject(undefined);
      this.toastService.showSuccess(this.t.tr('general.updated'));
      await this.getForeignObjects(this.serviceId);
    }
  }

  async onDelteForeignObject(id: number) {
    try {
      await this.foreignObjectService.delete(id);
      this.toastService.showSuccess(this.t.tr('general.entryDeleted'));
      await this.getForeignObjects(this.serviceId);
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  private getDimensions(net: Models.Net) {
    if (net.NetDimensionId) {
      this.netDimensionService
        .get(net.NetDimensionId + '?$expand=DimensionClass')
        .then((res) => {
          this.netdimension = res;
          this.createWeightNewNetString(res?.Weight);
        })
        .catch((err) => this.errorService.handleError(err));
    } else if (net.SpecialProductDimensionId) {
      this.specialProductDimensionService
        .get(net.SpecialProductDimensionId)
        .then((res) => {
          this.specialProductDimension = res;
        })
        .catch((err) => this.errorService.handleError(err));
    }
  }

  public canDeactivate() {
    if (!this.originalObject) {
      return true;
    }

    this.originalObject.WashedDate = moment.default(this.originalObject.WashedDate).format('YYYY-MM-DD') as any;
    this.service.WashedDate = moment.default(this.service.WashedDate).format('YYYY-MM-DD') as any;

    if (!this.utility.areEqual(this.service, this.originalObject)) {
      return this.dialogService
        .open({
          viewModel: Prompt,
          model: { header: 'dialog.pleaseConfirmHeader', message: 'dialog.unsavedChangesText' },
        })
        .whenClosed((response) => {
          if (response.wasCancelled) {
            return false;
          } else {
            const result = response.output;
            if (result === 'save') {
              // Save the service and let that function handle the rest of the logic
              this.saveService();
              return false;
            } else {
              this.eventAggregator.publish('changeTab-success', this.nextTabIndex);
              return true;
            }
          }
        });
    } else {
      this.eventAggregator.publish('changeTab-success', this.nextTabIndex);
      return true;
    }
  }

  private updateOriginalObject() {
    this.originalObject = JSON.parse(JSON.stringify(this.service));
  }

  createWeightNewNetString(weight: number) {
    if (weight) {
      this.weightNewNetString = `${this.t.tr('service.weightNewNet')}: ${this.netdimension.Weight} kg`;
    }
  }

  private radioButtonClear(radioButtonServiceField: string) {
    switch (radioButtonServiceField) {
      case 'ConditionUponReceipt':
        this.service.ConditionUponReceipt = null;
        break;
      case 'Fouling':
        this.service.Fouling = null;
        break;
      case 'CleanlinessAfterWashingOrganicDirt':
        this.service.CleanlinessAfterWashingOrganicDirt = null;
        break;
      case 'CleanlinessAfterWashingGreaseImpregnation':
        this.service.CleanlinessAfterWashingGreaseImpregnation = null;
        break;
      default:
        break;
    }
  }

  createHeaders() {
    this.headers = [
      { title: this.t.tr('service.detergentType') },
      { title: this.t.tr('general.articleno') },
      { title: this.t.tr('service.ConsumptionLiters') },
      { title: this.t.tr('service.disinfectionType') },
      { title: this.t.tr('general.articleno') },
      { title: this.t.tr('service.ConsumptionLiters') },
      { title: this.t.tr('general.actions') },
    ];
  }

  createHeadersConsumptionMaterialWashing() {
    this.headersConsumptionMaterialWashing = [
      { title: this.t.tr('consumptionMaterialWashing.title') },
      { title: this.t.tr('general.articleno') },
      { title: this.t.tr('general.locationCode') },
      { title: this.t.tr('general.comment') },
      { title: this.t.tr('general.amount') },
      { title: this.t.tr('general.actions') },
    ];
  }

  createHeadersForeignObject() {
    if (this.service.IsInvoicingCompatible) {
      this.foreignObjectHeaders = [
        { title: this.t.tr('service.foreignObject') },
        { title: this.t.tr('general.articleno') },
        { title: this.t.tr('general.comment') },
        { title: this.t.tr('general.amount') },
        { title: this.t.tr('general.actions') },
      ];
    } else {
      this.foreignObjectHeaders = [
        { title: this.t.tr('service.foreignObject') },
        { title: this.t.tr('general.comment') },
        { title: this.t.tr('general.amount') },
        { title: this.t.tr('general.actions') },
      ];
    }
  }

  private async getDisinfectionTypes() {
    const result = await this.serviceProductservice.getDisinfectionTypes('Washing', this.serviceId);
    return result.data;
  }

  private async getDetergentTypes() {
    const result = await this.serviceProductservice.getDetergentTypes('Washing', this.serviceId);
    return result.data;
  }

  private createValidationRules() {
    this.ruleBuilder
      .with(this.service)
      .required('CircumferenceMeasured')
      .required('CircumferenceMeasuredStretched')
      .required('CircumferenceMeasuredStretchedKg')
      .done();
  }

  private async validateCircumference(circumferenceMeasured: number) {
    const lowerLimit = this.netdimension.Circumference * 0.9;
    const upperLimit = this.netdimension.Circumference * 1.1;

    if (
      (circumferenceMeasured < lowerLimit || circumferenceMeasured > upperLimit) &&
      circumferenceMeasured != null &&
      circumferenceMeasured.toString() != ''
    ) {
      const approved = await this.confirmation.confirmYesCancel('dialog.areYouSure', 'service.tenPercentDeviationInCircumferenceAreYouSure');
      if (!approved) {
        this.service.CircumferenceMeasured = null;
      }
    }
  }

  private setCircumferenceMeasuredStretchedKg(isStretched: boolean) {
    if (isStretched) {
      this.service.CircumferenceMeasuredStretchedKg = 200;
    } else {
      this.service.CircumferenceMeasuredStretchedKg = null;
    }
  }

  private getAmountWasteText(invoiceWasteBy: InvoiceWasteBy) {
    switch (invoiceWasteBy) {
      case InvoiceWasteBy.Kg:
        this.amountWasteText = this.t.tr('service.amountWasteUnit', { x: this.t.tr('general.kilogram_short').toLowerCase() });
        this.unitWasteText = this.t.tr('general.kilogram_short').toLowerCase();
        break;
      case InvoiceWasteBy.Cubic:
        this.amountWasteText = this.t.tr('service.amountWasteUnit', { x: this.t.tr('general.cubic').toLowerCase() });
        this.unitWasteText = this.t.tr('general.cubic').toLowerCase();
        break;
      default:
        this.amountWasteText = this.t.tr('service.amountWasteUnit', { x: this.t.tr('general.kilogram_short').toLowerCase() });
        this.unitWasteText = this.t.tr('general.kilogram_short').toLowerCase();
        break;
    }
  }
}
